import React from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalContent,
  Button,
} from "@nextui-org/react";

const ConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  return (
    <>
      <Modal
        size="sm"
        isOpen={isOpen}
        onClose={onClose}
        className="p-3"
        placement="center"
      >
        <ModalContent>
          <ModalBody>
            <p className="text-center">Are You Sure You Want To Proceed?</p>
          </ModalBody>
          <ModalFooter className="flex justify-center gap-4">
            <Button color="primary" onPress={onConfirm}>
              Yes
            </Button>
            <Button color="danger" variant="light" onPress={onClose}>
              No
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ConfirmationModal;
